export default "__VITE_ASSET__DHO10jqO__"